// extracted by mini-css-extract-plugin
module.exports = {"desktopHeader":"OnboardingHeader_desktopHeader__2ofhp","logoLink":"OnboardingHeader_logoLink__174bV","banner":"OnboardingHeader_banner__3KC93"};